import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { supabase } from './backend/supabaseClient';
import { useProfile } from './backend/useProfile';
import Navbar from './widgets/Navbar/Navbar';
import PointeSense from './pages/PointeSense/PointeSenseDash';
import Login from './pages/Login/Login';
import Settings from './pages/Settings/Settings';
import ProtectedRoute from './pages/ProtectedRoute/ProtectedRoute';
import MyData from './pages/MyData/MyData';
import SessionDetail from './pages/SessionDetail/SessionDetail';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import './App.css';

const AppContent = ({ session, currentUser, handleLogout }) => {
  const location = useLocation();

  return (
    <div className="app">
      <Navbar
        currentUser={currentUser}
        onLogout={handleLogout}
      />
      <main className="main-content" key={location.pathname}>
        <Routes>
          <Route
            path="/"
            element={<LoginWrapper session={session} />}
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute isAuthenticated={!!session}>
                <PointeSense
                  session={session}
                  currentUser={currentUser}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute isAuthenticated={!!session}>
                <Settings
                  session={session}
                  currentUser={currentUser}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-data"
            element={
              <ProtectedRoute isAuthenticated={!!session}>
                <MyData
                  session={session}
                  currentUser={currentUser}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/session/:sessionId"
            element={
              <ProtectedRoute isAuthenticated={!!session}>
                <SessionDetail session={session} />
              </ProtectedRoute>
            }
          />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Routes>
      </main>
    </div>
  );
};

const App = () => {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const { profile } = useProfile(session?.user?.id);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleLogout = async () => {
    const { error } = await supabase.auth.signOut();
    if (error) console.error('Error logging out:', error);
  };

  if (loading) {
    return (
      <div className="app-loading">
        <div className="spinner"></div>
      </div>
    );
  }

  const currentUser = session?.user ? {
    ...session.user,
    username: profile?.username || session.user.email?.split('@')[0]
  } : null;

  return (
    <Router>
      <AppContent
        session={session}
        currentUser={currentUser}
        handleLogout={handleLogout}
      />
    </Router>
  );
};

const LoginWrapper = ({ session }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (session) {
      navigate('/dashboard');
    }
  }, [session, navigate]);

  if (session) {
    return null;
  }

  return <Login />;
};

export default App;
